import React from 'react'
import { SimpleGrid } from '@chakra-ui/react'

export default (props) => {
  return <SimpleGrid {...props} />
}
